import React from 'react';
import styled from '@emotion/styled';
import { cx } from '@emotion/css';
import { ComponentStyle, ProductListItem, TileTag } from '../../types/types';
import { StyleLibrary } from '@vm/omega-shared-component-webapp';
import { TileTp } from './TileTp';
import { Tile } from './Tile';
import { filterTiles } from './utils';

const { mqBreakpoints, pxToRem } = StyleLibrary;

const Container = styled.div({
  maxWidth: '100%',
  margin: `${pxToRem(48)} 0 ${pxToRem(24)}`,

  [mqBreakpoints.desktop]: {
    margin: pxToRem(32),
  },
});

const Ul = styled.ul({
  display: 'grid',
  gridColumnGap: pxToRem(88),
  gridRowGap: pxToRem(32),
  gridTemplateColumns: 'repeat(1, 1fr)',
  gridTemplateRows: 'auto',
  zIndex: 1,

  [mqBreakpoints.tablet]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },

  [mqBreakpoints.desktop]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },

  '&.A': {
    gridColumnGap: pxToRem(48),

    [mqBreakpoints.desktop]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
});

type Props = {
  tileItems: ProductListItem[];
  filter: string;
  selectedProductIndex: number;
  handleTileClick: (i: number) => void;
  style: ComponentStyle;
};

const TileSet: React.FC<Props> = ({ tileItems, filter, selectedProductIndex, style, handleTileClick }) => {
  const filteredTileItems = filter === TileTag.All ? tileItems : filterTiles(tileItems, filter);

  return (
    <Container data-testid='mp-tiles-tileset'>
      <Ul className={cx('unstyled', style)}>
        {filteredTileItems?.map((tile, index) => {
          const isSelected = index === selectedProductIndex;

          switch (style) {
            case ComponentStyle.B:
              return <TileTp key={index} tile={tile} index={index} isSelected={isSelected} onClick={handleTileClick} />;
            default:
              return <Tile key={index} tile={tile} index={index} isSelected={isSelected} onClick={handleTileClick} />;
          }
        })}
      </Ul>
    </Container>
  );
};

export default TileSet;
